@use "ui/styles/colorsOld";
@use "ui/styles/fonts";
@use "ui/styles/fontsOld";
@use "ui/styles/sizes";
@use "ui/oldStyles/variables/spacing";
@use "ui/styles/studio";

.entityList {
  font-weight: 400;
  background: transparent;

  &:not(.omitPaddingLeftRight) {
    padding: 0 10px;
  }

  // ul directives override orderable list styles
  ul {
    list-style: none;
    margin: 0;
  }

  .searchWrapper {
    padding: 8px;
  }
}

.buttonIcon {
  @include studio.studioEntityButton;
}

.inspectorSelect {
  width: 100%;
  display: flex;
  align-items: center;

  span {
    display: block;
    text-transform: uppercase;
    font-size: fontsOld.$small;
    color: studio.$studioColorLight;
    margin-bottom: 4px;
  }

  input {
    height: 28px;
    padding: 0 6px;
    border-color: studio.$studioBorderColor;
  }

  &:not(.disabled) {
    input {
      &:hover {
        border-color: studio.$studioBorderColor;
      }

      &:focus {
        border-color: studio.$studioBorderColor;
      }
    }
  }
}

.floatingDropdownMenuWrapper {
  position: absolute;
  top: 25px;
  right: 20.5px;
  width: 175px;
  z-index: 100;
  box-shadow: 0 0 6px 4px studio.$studioColor 3px;
}

.floatingDropdownPositionLeft {
  right: unset;
  left: 0;
}

.dropdownMenuItem {
  &.disabled {
    color: studio.$studioColorLight !important;
    cursor: not-allowed !important;

    &:hover {
      background-color: studio.$studioBackgroundColorLimit !important;
    }
  }
}

.inspectorHeader {
  font-weight: 500;
  border-top: 1px solid studio.$studioBorderColor;
  width: 100%;

  &:first-child {
    border-top: 0 solid studio.$studioBorderColor;
  }
}

.fatFlexRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
  padding-bottom: 8px;
}

.fatRow {
  padding: 8px 0;
}

.thinFlexRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pumpFlexRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 4px;
  padding-bottom: 4px;
}

.validationErrorContainer {
  background-color: colorsOld.$rubyLightX2;
  color: studio.$studioBackgroundColorLimit;
  border: 1px solid colorsOld.$rubyDark;
  border-radius: 4px;
  padding: 4px;
}

.validationErrorMessage {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: stretch;
}

.editableHeader {
  padding: 8px;
}

.editableList {
  border-top: 1px solid studio.$studioBorderColor;
  border-bottom: 1px solid studio.$studioBorderColor;

  > div {
    padding: 4px 8px;
    background-color: studio.$studioBackgroundColor;
    border-bottom: 1px solid studio.$studioBorderColor;
  }

  > div:last-child {
    border-bottom: none;
  }
}

.sectionTitleH1 {
  font-weight: 400;
  font-size: 10px;
  text-transform: uppercase;
  padding: 0 8px 4px 0;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sectionTitleSpan {
  font-weight: 600;
  text-transform: uppercase;
  padding: 0;
  margin: 0;
}

.selectButtonGroupWrapper {
  display: flex;
  align-items: center;
  width: 100%;

  select,
  input:first-child {
    border-radius: 4px 0 0 4px;
  }

  button:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.selectButtonGroupButton {
  height: 24px;
  border: 1px solid studio.$studioBorderColor;
  border-left: 1px solid transparent;
  color: studio.$studioColor;
  background-color: studio.$studioBackgroundColorLimit;
  transition: background-color 0.15s;
  font-weight: fonts.$medium;

  &:hover {
    background-color: studio.$studioHoverBackgroundColor;
    color: studio.$studioColorSelected;
    border-color: studio.$studioColorSelected;
    border-left: 1px solid studio.$studioColorSelected;
  }
}

.inspectorNote {
  margin-bottom: sizes.$s4;

  &.noteCentered {
    text-align: center;
  }

  &.noteSizeBase {
    font-size: fonts.$base;
  }

  &.noteSizeSmall {
    font-size: fonts.$small;
  }

  &.noteSizeXSmall {
    font-size: fonts.$smallX1;
  }

  &.noteWeightMedium {
    font-weight: fonts.$medium;
  }

  &.notePadded {
    padding: sizes.$s6;
  }
}

.inspectorTextAreaWrapper {
  padding: 0 studio.$studioRowSidePadding;
  display: flex;
  flex-direction: column;
  gap: 4px;

  & > label {
    padding-left: 2px;
  }
}

.deferredSelectWrapper {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 3px;

  &:hover {
    border: 1px solid studio.$studioBorderColor;
  }
}

.editableSetAddButton {
  min-width: 80px;
  height: studio.$studioRowHeight;
  border: solid 1px #dedede;
  border-right: none;
  padding: 2px;
}

.inspectorIconButtonGroupWrapper {
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    background-color: studio.$studioBackgroundColorLimit;
    border-right: 1px solid studio.$studioBorderColor;
    padding: 4.5px;
    display: flex;
    align-items: center;
    height: 24px;

    &:hover {
      background-color: studio.$studioHoverBackgroundColor;
    }
  }

  button:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  button:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.inspectorImage {
  width: 100%;
  max-height: 200px;
  object-fit: contain;
  cursor: pointer;
}

.inspectorImageScaled {
  width: 700px;
  object-fit: contain;
  cursor: pointer;
}

.externalEntityLinkWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  position: relative;
  padding: 9px 10px 9px 12px;
  margin: 0 -12px;
  transition: background-color 0.1s ease-in;

  a {
    text-decoration: none;
    display: flex;
    justify-content: space-between;
    color: inherit;
    align-items: center;
    width: 100%;
  }

  &:hover {
    cursor: pointer;
    background-color: studio.$studioHoverBackgroundColor;
    color: studio.$studioColorSelected;
  }
}

.externalEntityLinkLabelWrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.active {
  font-weight: 700;
}

.clearableRotationControls {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.inspectorToggleButtonsWrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 1px;
  height: calc(100% - 2px);
  width: fit-content;
  background-color: studio.$studioBackgroundColor;
  border-radius: studio.$studioBorderRadius;

  button {
    border: 0.5px solid studio.$studioBorderColor !important;
  }

  button:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    min-width: 50%;

    &.inspectorToggleButtonSelected {
      border-right: 0.5px solid transparent;
    }

    border-right: none !important;
  }

  button:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    min-width: 50%;

    &.inspectorToggleButtonSelected {
      border-left: 0.5px solid transparent;
    }
  }

  & button.inspectorToggleButtonSelected {
    background-color: studio.$studioBackgroundColorLimit;
    opacity: 1;
    cursor: auto;
    color: studio.$studioColor;
    height: 100%;
  }

  & button:not(.inspectorToggleButtonSelected) {
    background-color: studio.$studioHoverBackgroundColor;
    opacity: 0.8;
    color: studio.$studioColor;

    &:hover {
      color: studio.$studioColorSelected;
      background-color: studio.$studioHoverBackgroundColor;
    }
  }
}

.infoWrapper {
  border-radius: 100%;
  color: studio.$studioColorLight;
  background-color: studio.$studioHoverBackgroundColor;
  height: 18px;
  width: 18px;
  margin-left: 6px;
  position: relative;
  cursor: pointer;
  transform: scale(0.95);

  a {
    color: studio.$studioColor !important;
  }
}

.flyoutStudioTableWrapper {
  padding: 0 10px;
}
